import { SchemaMetadataStore } from './schema-metadata.store';
import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';

@Injectable({ providedIn: 'root' })
export class SchemaMetadataQuery extends BaseQuery {
  constructor(store: SchemaMetadataStore) {
    super(store);
  }
}
